/**
 * Brazil's NATIONAL holidays (W9-TIME-BANDS-SURGE, D464, ADR-0082; DevMobility B-066 "Cadastro de Feriados" — the national
 * ones seeded by the country pack, the regional and municipal ones left to each market's operators). Plain pack DATA:
 * `@vello/pack-seed` builds the governed `calendar.holidays` version with the key's own builder and publishes it through the
 * governed seed path (maker ≠ approver).
 *
 * The legal national holidays only (Lei 662/1949 and its updates): Confraternização Universal (1 Jan), Sexta-feira Santa
 * (Good Friday, the one movable holiday — two days before Easter Sunday, the Gregorian computus), Tiradentes (21 Apr), Dia do
 * Trabalho (1 May), Independência (7 Sep), Nossa Senhora Aparecida (12 Oct), Finados (2 Nov), Proclamação da República
 * (15 Nov), Consciência Negra (20 Nov, national since 2024) and Natal (25 Dec). Carnaval and Corpus Christi are "ponto
 * facultativo" nationally (a state or city law makes them holidays), so they are NOT here — a market adds them under four eyes.
 *
 * The seed carries the years 2026–2028; a later year is a new version a human publishes (a version carries the whole list).
 */
/** The years the first version carries. */
export const BRAZIL_HOLIDAY_YEARS = [2026, 2027, 2028];
/** The vigência of the first version (the same instant family as the other pack seeds). */
export const BRAZIL_HOLIDAY_EFFECTIVE_FROM = '2026-10-01T00:00:00Z';
/** Easter Sunday of a Gregorian year, as `[month (1-12), day]` — the anonymous Gregorian computus (Meeus/Jones/Butcher). */
export function easterSunday(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return [month, day];
}
const pad = (n) => String(n).padStart(2, '0');
const isoDate = (d) => `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
/** The national holidays of one year, in date order. */
export function brazilNationalHolidays(year) {
    const [em, ed] = easterSunday(year);
    const goodFriday = new Date(Date.UTC(year, em - 1, ed - 2));
    const fixed = [
        ['01-01', 'Confraternização Universal'],
        ['04-21', 'Tiradentes'],
        ['05-01', 'Dia do Trabalho'],
        ['09-07', 'Independência do Brasil'],
        ['10-12', 'Nossa Senhora Aparecida'],
        ['11-02', 'Finados'],
        ['11-15', 'Proclamação da República'],
        ['11-20', 'Consciência Negra'],
        ['12-25', 'Natal'],
    ];
    const all = fixed.map(([md, name]) => ({ date: `${year}-${md}`, name, kind: 'NATIONAL' }));
    all.push({ date: isoDate(goodFriday), name: 'Sexta-feira Santa', kind: 'NATIONAL' });
    return all.sort((x, y) => (x.date < y.date ? -1 : 1));
}
/** The first version's value: every national holiday of {@link BRAZIL_HOLIDAY_YEARS}. */
export const BRAZIL_HOLIDAY_CALENDAR_V1 = {
    holidays: BRAZIL_HOLIDAY_YEARS.flatMap((y) => brazilNationalHolidays(y)),
};
//# sourceMappingURL=holidays.js.map